import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessSeguimientoEjecutivo } from '../utils/gestionCampanaAccess'

const RequirePruebaSofiaAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessSeguimientoEjecutivo(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequirePruebaSofiaAccess
